import * as React from 'react';
import { Provider } from 'react-redux';

import { render } from 'react-dom';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import Root from './components/app';
import favoritesReducer from './redux/reducers/favorites-reducer';
import apiReducer from './redux/reducers/api-reducer';

const favoriteContainers = document.getElementsByClassName('favorites-container-js');

for (let i = 0; i < favoriteContainers.length; ++i) {
    const favoriteContainer = favoriteContainers[i];

    const combined = combineReducers({ favoritesState: favoritesReducer, apiState: apiReducer });

    const store = createStore(
        combined,
        {
            favoritesState: {
                isFavorite: favoriteContainer.getAttribute('data-is-favorite').toLocaleLowerCase() == 'true',
                pageKey: favoriteContainer.getAttribute('data-page-key'),
                isLoggedIn: favoriteContainer.getAttribute('data-logged-in').toLocaleLowerCase() == 'true'
            }
        },
        applyMiddleware(thunk)
    );

    render(
        <Provider store={store}>
            <Root />
        </Provider>,
        favoriteContainer
    );
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/favorites/index.tsx